// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2v7re","container":"styles_container__3l81J","title":"styles_title__1BnTd","wrapper":"styles_wrapper__6Rtdg","answer":"styles_answer__1RMXD"};